module.exports = __webpack_public_path__ + "img/alentour22.0ecce1c1.jpg";